"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositionRenderer = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const log_1 = require("../log");
const components_renderer_1 = require("./components-renderer");
const compositionDebug = log_1.jrlDebug.extend('composition');
const CompositionRenderer = ({ services, layoutApi, componentRenderPath, composition, compositionMiddleware, componentRegistrations, componentMiddleware, compositionRegistrations, additionalComponentProps, }) => {
    /**
     * The ContentAreaRenderer componentRenderPaths need to append `/[contentArea key]'
     * key as this logic is duped outside of react for the ssr
     */
    compositionDebug('Rendering: %o', {
        type: composition.type,
        componentRenderPath: componentRenderPath,
    });
    const { contentAreas, props: compositionProps, ...middlewareProps } = composition;
    const componentServices = {
        services: services,
        layout: layoutApi,
    };
    const compositionRegistration = compositionRegistrations.get(composition.type);
    if (!compositionRegistration) {
        return null;
    }
    // A middleware may call next with props, we should use them
    function render(middlewareCompositionProps) {
        const compositionRenderProps = {
            ...additionalComponentProps,
            ...(middlewareCompositionProps || compositionProps),
        };
        const contentAreas = Object.keys(composition.contentAreas).reduce((acc, contentAreaName) => {
            const componentsRenderPath = `${componentRenderPath}/${contentAreaName}`;
            compositionDebug('Rendering content area: %o', {
                componentsRenderPath,
                components: composition.contentAreas[contentAreaName].map(component => ({
                    type: component.type,
                })),
            });
            const additionalProps = (compositionRegistration === null || compositionRegistration === void 0 ? void 0 : compositionRegistration.componentProps)
                ? compositionRegistration === null || compositionRegistration === void 0 ? void 0 : compositionRegistration.componentProps(contentAreaName, compositionRenderProps)
                : {};
            acc[contentAreaName] = (react_1.default.createElement(components_renderer_1.ComponentsRenderer, { componentMiddleware: componentMiddleware, componentRegistrations: componentRegistrations, componentRenderPath: componentsRenderPath, components: composition.contentAreas[contentAreaName], layoutApi: layoutApi, services: services, additionalComponentProps: additionalProps }));
            return acc;
        }, {});
        const rendered = compositionRegistration.render(contentAreas, compositionRenderProps, services) || null;
        return rendered;
    }
    const middlewareRender = compositionMiddleware({
        layoutType: composition.type,
        renderPath: componentRenderPath,
        ...composition.props,
    }, middlewareProps, componentServices, render) || null;
    return middlewareRender;
};
exports.CompositionRenderer = CompositionRenderer;
exports.CompositionRenderer.displayName = 'CompositionRenderer';
//# sourceMappingURL=composition-renderer.js.map